import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentFilter: "all",
  currentPageSize: 20,
  sortBy: "",
  sortOrder: "",
  search: "",
  showAddModal: false,
  showDeleteModal: false,
  clearSelection: false,
  selectedItem: "",
  isEdit: false,
  itemData: [],
  serviceItems: [],
  downloadingId: "",
  supplier_id: "",
  item_id: "",
};

const designBankSlice = createSlice({
  name: "designBank",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = designBankSlice.actions;

export default designBankSlice.reducer;
